export const BILLING_ANALYTICS_EVENTS = {
  grpSponsorContributionUploaded: "billing grp sponsor contribution uploaded",
  paymentsViewed: "billing payments viewed",
  payoutProfilesViewed: "billing payout profiles viewed",
  duesRatesUpdated: "billing dues rates updated",
  duesRatesFinalized: "billing dues rates finalized",
  draftOrderCreated: "billing draft order created",
  orderOpened: "billing order opened",
  orderCanceled: "billing order canceled",
  orderDueDateChanged: "billing order due date changed",
  programsSuspended: "billing programs suspended",
  programsTerminated: "billing programs terminated",
  bulkOrderDueDatesChanged: "billing bulk order due dates changed",
  checkPaymentApplied: "billing check payment applied",
  paymentRefunded: "billing payment refunded",
  orderUpdated: "billing order updated",
  orderSetToDraft: "billing order set to draft"
} as const;

export type BillingAnalyticsSource =
  | "grp_sponsor_contributions_upload"
  | "payments_tab"
  | "payout_profiles_tab"
  | "dues_rates"
  | "orders"
  | "suspensions_and_terminations"
  | "apply_payment"
  | "edit_order";

export type BillingAnalyticsData = {
  source: BillingAnalyticsSource;
  success: boolean;
  contributionCount?: number;
  quarterSelection?: "current" | "previous";
  orderId?: string;
  paymentId?: string;
  rateCount?: number;
  personCount?: number;
  orderCount?: number;
  resultCount?: number;
  action?: string;
};

export function getBillingAnalyticsData({
  source,
  success = true,
  ...rest
}: {
  source: BillingAnalyticsSource;
  success?: boolean;
} & Omit<BillingAnalyticsData, "source" | "success">): BillingAnalyticsData {
  return {
    source,
    success,
    ...Object.fromEntries(Object.entries(rest).filter(([, value]) => value !== undefined && value !== null))
  };
}
